import React from 'react';
import { Typography, RegularButton } from 'fronton-react';
import * as styles from './fallback.styles';

export const Fallback = () => {
  const handleReloadPage = () => {
    location.reload();
  };

  return (
    <div className={styles.container}>
      <div className={styles.image}>
        <img
          src="https://cdn.lemanapro.ru/lmru/image/upload/v1738310382/fudzi/Presale/error.svg/error.svg"
          alt="Что-то пошло не так"
          width={288}
          height={180}
        />
      </div>
      <div className={styles.title}>
        <Typography variant="m" size="body_accent" color="text-primary">
          Попробуйте повторить
        </Typography>
      </div>
      <div className={styles.description}>
        <Typography variant="m" size="body_short" color="text-primary">
          Не удалось загрузить калькулятор
        </Typography>
      </div>
      <RegularButton
        data-testid="calculate-fallback-reload-button"
        size="l"
        variant="secondary"
        onClick={handleReloadPage}>
        Обновить
      </RegularButton>
    </div>
  );
};
